// extracted by mini-css-extract-plugin
export default {"container":"explore-dining_container__DXLVP"};